import { User } from '../types/user';

const dummyUsers: User[] = [
    {
        id: 1,
        foto: 'https://randomuser.me/api/portraits/men/1.jpg',
        nombre: 'Juan Pérez',
        correo: 'juan.perez@email.com',
        telefono: '555-1234',
        rol: 'Administrador',
        activo: true,
        permissions: {
            Dashboard: [true, true, true, true],
            Agentes: [true, false, true, false],
            Inbox: [true, true, false, false],
            Contactos: [true, false, false, false],
            Usuarios: [true, true, true, true],
        },
    },
    {
        id: 2,
        foto: 'https://randomuser.me/api/portraits/women/2.jpg',
        nombre: 'Ana Gómez',
        correo: 'ana.gomez@email.com',
        telefono: '555-5678',
        rol: 'Usuario',
        activo: false,
        permissions: {
            Dashboard: [true, false, false, false],
            Agentes: [false, false, false, false],
            Inbox: [true, true, false, false],
            Contactos: [true, false, false, false],
            Usuarios: [false, false, false, false],
        },
    },
];

export const usersApi = {
    getUsers: async (): Promise<User[]> => {
        await new Promise(res => setTimeout(res, 200));
        return dummyUsers;
    },
    getUserById: async (id: number): Promise<User | undefined> => {
        await new Promise(res => setTimeout(res, 100));
        return dummyUsers.find(u => u.id === id);
    },
};
